var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4893 4.29306C15.2084 2.57403 17.9955 2.57403 19.7145 4.29306C21.4335 6.01209 21.4335 8.7992 19.7145 10.5182L18.643 11.5898C18.2914 11.9414 17.7213 11.9414 17.3696 11.5898C17.018 11.2381 17.018 10.668 17.3696 10.3164L18.4412 9.2449C19.457 8.22911 19.457 6.58218 18.4412 5.56639C17.4254 4.5506 15.7785 4.5506 14.7627 5.56639L11.2256 9.10342C10.2098 10.1192 10.2098 11.7661 11.2256 12.7819C11.5773 13.1335 11.5773 13.7036 11.2256 14.0553C10.874 14.4069 10.3039 14.4069 9.95231 14.0553C8.23328 12.3362 8.23328 9.54912 9.95231 7.83009L13.4893 4.29306ZM12.7819 9.95231C13.1335 9.60069 13.7036 9.60069 14.0553 9.95231C15.7743 11.6713 15.7743 14.4584 14.0553 16.1775L10.5182 19.7145C8.7992 21.4335 6.01209 21.4335 4.29306 19.7145C2.57403 17.9955 2.57403 15.2084 4.29306 13.4893L5.41486 12.3675C5.76648 12.0159 6.33657 12.0159 6.68819 12.3675C7.03981 12.7192 7.03981 13.2892 6.68819 13.6409L5.56639 14.7627C4.5506 15.7785 4.5506 17.4254 5.56639 18.4412C6.58218 19.457 8.22911 19.457 9.2449 18.4412L12.7819 14.9042C13.7977 13.8884 13.7977 12.2414 12.7819 11.2256C12.4303 10.874 12.4303 10.3039 12.7819 9.95231Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedOutline);
export default __webpack_public_path__ + "static/media/linked_outline.a7346b63a2867028a98b9a852d210a63.svg";
export { ForwardRef as ReactComponent };